import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { toast } from 'sonner';
import { AdminHeader, AdminTable } from './AdminShared';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { ADMIN } from '@/constants/testIds';

const EMPTY = { name: '', date: '', description: '', clinic_ids: [] };

export default function HolidaysTab() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get('/holidays'); setRows(data); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await api.post('/holidays', form);
      toast.success('Saved'); setOpen(false); setForm(EMPTY); load();
    } catch (err) { toast.error(err?.response?.data?.detail || 'Failed to save'); }
  };
  const remove = async (r) => {
    if (!window.confirm(`Delete ${r.name}?`)) return;
    await api.delete(`/holidays/${r.id}`); load();
  };

  return (
    <div>
      <AdminHeader
        title="Holidays & Closures"
        description="Enterprise or clinic-specific closures that block scheduling."
        onCreate={() => { setForm(EMPTY); setOpen(true); }}
        createLabel="New Holiday"
        createTestId={ADMIN.createButton('holiday')}
      />
      <AdminTable
        loading={loading} rows={rows}
        columns={[
          { key: 'date', label: 'Date' },
          { key: 'name', label: 'Name' },
          { key: 'scope', label: 'Scope', render: (r) => r.clinic_ids?.length ? `${r.clinic_ids.length} clinics` : 'All clinics' },
          { key: 'description', label: 'Description' },
        ]}
        rowTestId={ADMIN.row}
        onDelete={remove}
      />
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>New Holiday</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div>
              <Label>Name</Label>
              <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="h-9" data-testid="holiday-field-name" />
            </div>
            <div>
              <Label>Date</Label>
              <Input type="date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} className="h-9" data-testid="holiday-field-date" />
            </div>
            <div>
              <Label>Description</Label>
              <Input value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="h-9" />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={save} className="bg-stone-900 hover:bg-stone-800 text-white" data-testid={ADMIN.saveButton}>Save</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
